import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import ImageWithBasePath from '../../../core/common/imageWithBasePath';
import { svgIcons } from '../../../style/fonts/SvgIcons';
import TextArea from 'antd/es/input/TextArea';
import Select, { StylesConfig } from "react-select";
import { useCreateContactMutation, useGetAllAccountsQuery, useGetContactLookupQuery, useUpdateContactMutation } from "../../../services/EndPointsApis";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "../../../Features/authslice";
import TextField from '../../../core/common/textFields/TextField';
import { InputMask } from '@react-input/mask';
import { removeImage, setImage } from '../../../Features/commonSlice';
import { RootState } from '../../../store';



const ContactsSidebar = ({ activityTogglePopup, AccountId, AccountName, closeSidebar, isEditing, viewOnly, contactData, createContact, data, isError, error, isSuccess, isLoading }: any) => {
    const dispatch = useDispatch();
    const customStyles: StylesConfig = {
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused ? "rgba(177, 31, 40, 1)" : "#fff",
            color: state.isFocused ? "#fff" : "#000",
            "&:hover": {
                backgroundColor: "rgba(177, 31, 40, 1)",
            },
        }),
    };
    const [updateId, setUpdateId] = useState(0);
    const imageUrl = useSelector((state: RootState) => state.common?.imageUrl);
    const fileInputRef = useRef<HTMLInputElement | null>(null);

    const contactSchema = Yup.object().shape({
        contactType: Yup.object({
            id: Yup.number().min(1, 'Contact Type must be selected').required('Contact Type Id is required'),
            name: Yup.string().required('Contact Type is required')
        }).required(),
        contactStatus: Yup.object({
            id: Yup.number().min(1, 'Contact Status must be selected').required('Contact Status Id is required'),
            name: Yup.string().required('Contact Status is required')
        }).required(),
        // lst_Account: Yup.object({
        //     id: Yup.string().min(1, 'Account must be selected').required('Account Id is required'),
        //     value: Yup.string().required('Account is required')
        // }).required(),
        firstName: Yup.string().required("First Name is required"),
        salutation: Yup.object({
            id: Yup.number().min(1, 'Salutation Id must be selected').required('Salutation Id is required'),
            name: Yup.string().required('Salutation is required')
        }).required(),
        lastName: Yup.string().required("Last Name is required"),
    });

    const initialValues = {
        contactId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        accountId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        contactNo: '',
        organizationId: 0,
        firstName: '',
        lastName: '',
        email: '',
        imageUrl: '',
        note: '',
        updatedBy: "",
        createdDT: "2024-09-11T12:04:49.777Z",
        updatedDT: "2024-09-11T12:04:49.777Z",
        companyName: '',
        homePhone: '',
        workPhone: '',
        cellPhone: '',
        fax: '',
        isActive: true,
        homeEmail: '',
        workEmail: '',
        perferredTime: '2024-09-11T12:04:49.777Z',
        sourceDescription: '',
        isSubNewsLetter: true,
        isPrimaryContact: true,
        addressLine1: '',
        addressLine2: '',
        city: '',
        state: '',
        zipCode: '',
        country: {
            id: 0,
            title: ''
        },
        contactType: {
            id: 0,
            name: ''
        },
        contactStatus: {
            id: 0,
            name: ''
        },
        salutation: {
            id: 0,
            name: ''
        },
        maritalStatus: {
            id: 0,
            name: ''
        },
        genderType: {
            id: 0,
            name: ''
        },
        inquiryMethod: {
            id: 0,
            name: ''
        },
        leadSource: {
            id: 0,
            name: ''
        },
        preferredMethod: {
            id: 0,
            name: ''
        },
        lst_Account: {
            id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
            value: ''
        }
    };

    const [UpdateContact, { data: updatedata, isError: updateIsError, error: updateError, isSuccess: updateIsSuccess, }] =
        useUpdateContactMutation();
    const { data: getContactLookup, refetch } = useGetContactLookupQuery('');

    const { data: allAccounts, refetch: allAccountsRefetch } = useGetAllAccountsQuery('');


    const formik = useFormik({
        validationSchema: contactSchema,
        initialValues,
        onSubmit: (values) => {
            if (isEditing) {
                UpdateContact({ ...values })
            } else {
                createContact({ ...values });
            }
        },
    });
    const { resetForm } = formik;

    useEffect(() => {
        refetch();

    }, [])

    useEffect(() => {
        if (!contactData) {
            resetForm()
        }

    }, [closeSidebar])

    useEffect(() => {
        if (contactData && Object.keys(contactData).length > 0) {
            setUpdateId(contactData?.contactId);
            formik.setValues({ ...contactData });
        } else {
            // resetForm();
        }
    }, [contactData, updateId]);

    const handleContactType = (selectedOption: any) => {
        formik.setFieldValue(' inquiryMethod', selectedOption);
    };
    const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            const imageUrl = URL.createObjectURL(file);
            dispatch(setImage(imageUrl));
            formik.setFieldValue('imageUrl', imageUrl);
            formik.setFieldValue('file', file);
        }
    };
    const handleRemoveImage = () => {
        dispatch(removeImage());
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };
    useEffect(() => {
        if (isSuccess) {
            toast.success(data?.message);
            closeSidebar();
            resetForm();
            // refetchContacts()
        }
        if (updateIsSuccess) {
            toast.success(updatedata?.message);
            closeSidebar();
            // refetchContacts()
        }

    }, [isSuccess, updateIsSuccess]);

    useEffect(() => {
        if (isError && error) {
            let errorMessage: string = 'Something went wrong';
            if ('data' in error && error.data && typeof error.data === 'object' && 'message' in error.data) {
                errorMessage = (error.data as { message: string }).message;
            }
            toast.error(errorMessage);
        }
    }, [isError, error]);

    useEffect(() => {
        if (!activityTogglePopup && !isEditing && !contactData) {
            resetForm();
        }
        if (AccountId && AccountName) {
            formik.setFieldValue('lst_Account.id', AccountId);
            formik.setFieldValue('lst_Account.value', AccountName);
        }
    }, [activityTogglePopup]);
    const handleSubmit = (event: any) => {
        event.preventDefault();
        formik.handleSubmit()
    }
    return (
        <div className={activityTogglePopup ? "toggle-popup sidebar-popup" : "toggle-popup"}>
            <div className="sidebar-layout">
                <div className="sidebar-header">
                    <h4>
                        {isEditing ? "Edit Contact" : viewOnly ? 'View Contact' : 'Add Contact'}
                    </h4> <Link to="#" className="sidebar-close toggle-btn" onClick={closeSidebar}>
                        <i className="ti ti-x" />
                    </Link>
                </div>
                <div className="toggle-body">
                    <div className="pro-create">
                        <form onSubmit={formik.handleSubmit} >
                            <div className="accordion-lists" id="list-accords">
                                <div className="user-accordion-item">
                                    <Link
                                        to="#"
                                        className="accordion-wrap"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#edit-basic"
                                    >
                                        {/* <span>
                                            <i className="ti ti-user-plus" />
                                        </span> */}
                                        Contact Person
                                    </Link>
                                    <div
                                        className="accordion-collapse collapse show"
                                        id="edit-basic"
                                        data-bs-parent="#list-accords"
                                    >
                                        <div className="content-collapse">
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="profile-pic-upload">
                                                        <div className="profile-pic">
                                                            <span className="position-absolute top-0 start-100 translate-middle pointer" onClick={handleRemoveImage}>
                                                                {svgIcons.DeleteIcon}
                                                            </span>
                                                            <img
                                                                src={imageUrl || '/assets/img/profile/default-upload-img.svg'}
                                                                alt="img"
                                                                className="preview1"
                                                            />
                                                        </div>
                                                        <div className="upload-content">
                                                            <div className="upload-btn">
                                                                <input
                                                                    type="file"
                                                                    accept=".png, .jpg, .jpeg"
                                                                    onChange={handleImageChange}
                                                                    ref={fileInputRef}
                                                                />
                                                                <span>
                                                                    <i className="ti ti-upload" />
                                                                    Upload Image
                                                                </span>
                                                            </div>
                                                            <p>JPG, GIF or PNG. Max size of 800K</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-wrap">
                                                        <label className="input-label">
                                                            Contact Type{" "} <span className="text-danger">*</span>
                                                        </label>
                                                        <Select
                                                            styles={customStyles}
                                                            className="select"
                                                            options={getContactLookup?.result?.contactTypes?.map((option: any) => ({
                                                                label: option?.name,
                                                                value: option?.id
                                                            }))}
                                                            value={
                                                                formik.values?.contactType?.id
                                                                    ? {
                                                                        value: formik.values?.contactType?.id,
                                                                        label: formik.values?.contactType?.name || '',
                                                                    }
                                                                    : null
                                                            }
                                                            isDisabled={viewOnly}
                                                            onChange={(selectedOption: any) => {
                                                                formik.setFieldValue('contactType.id', selectedOption.value);
                                                                formik.setFieldValue('contactType.name', selectedOption.label);

                                                            }}
                                                        />
                                                    </div>
                                                    {formik.touched.contactType && formik.errors.contactType && (
                                                        <div className="error">{formik.errors.contactType?.id}</div>
                                                    )}
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-wrap">
                                                        <label className="input-label">
                                                            Contact Status{" "} <span className="text-danger">*</span>
                                                        </label>
                                                        <Select
                                                            styles={customStyles}
                                                            className="select"
                                                            options={getContactLookup?.result?.contactStatusTypes?.map((option: any) => ({
                                                                label: option?.name,
                                                                value: option?.id
                                                            }))}
                                                            value={
                                                                formik.values?.contactStatus?.id
                                                                    ? {
                                                                        value: formik.values?.contactStatus?.id,
                                                                        label: formik.values?.contactStatus?.name || '',
                                                                    }
                                                                    : null
                                                            }
                                                            isDisabled={viewOnly}
                                                            onChange={(selectedOption: any) => {
                                                                formik.setFieldValue('contactStatus.id', selectedOption.value);
                                                                formik.setFieldValue('contactStatus.name', selectedOption.label);
                                                            }}
                                                        />
                                                    </div>
                                                    {formik.touched.contactStatus && formik.errors.contactStatus && (
                                                        <div className="error">{formik.errors.contactStatus?.id}</div>
                                                    )}
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-wrap">
                                                        <TextField
                                                            label="Company Name"
                                                            type="text"
                                                            {...formik.getFieldProps("companyName")}
                                                            disabled={viewOnly}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-wrap">
                                                        <label className="input-label">
                                                            Salutation{" "} <span className="text-danger">*</span>
                                                        </label>
                                                        <Select
                                                            styles={customStyles}
                                                            className="select"
                                                            options={getContactLookup?.result?.salutationTypes?.map((option: any) => ({
                                                                label: option?.name,
                                                                value: option?.id
                                                            }))}
                                                            value={
                                                                formik.values?.salutation?.id
                                                                    ? {
                                                                        value: formik.values?.salutation?.id,
                                                                        label: formik.values?.salutation?.name || '',
                                                                    }
                                                                    : null
                                                            }
                                                            isDisabled={viewOnly}
                                                            onChange={(selectedOption: any) => {
                                                                formik.setFieldValue('salutation.id', selectedOption.value);
                                                                formik.setFieldValue('salutation.name', selectedOption.label);

                                                            }}
                                                        />
                                                    </div>
                                                    {formik.touched.salutation?.id && formik.errors.salutation?.id && (
                                                        <div className="error">{formik.errors.salutation?.id}</div>
                                                    )}
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-wrap">
                                                        <TextField
                                                            label=" First Name"
                                                            type="text"
                                                            required
                                                            {...formik.getFieldProps("firstName")}
                                                            disabled={viewOnly}
                                                        />
                                                    </div>
                                                    {formik.touched.firstName && formik.errors.firstName && (
                                                        <div className="error">{formik.errors.firstName}</div>
                                                    )}
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-wrap">
                                                        <TextField
                                                            label="Last Name"
                                                            type="text"
                                                            required
                                                            {...formik.getFieldProps("lastName")}
                                                            disabled={viewOnly}
                                                        />
                                                    </div>
                                                    {formik.touched.lastName && formik.errors.lastName && (
                                                        <div className="error">{formik.errors.lastName}</div>
                                                    )}
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-wrap">
                                                        <label className="input-label">
                                                            Account{" "} <span className="text-danger">*</span>
                                                        </label>
                                                        <Select
                                                            styles={customStyles}
                                                            className="select"
                                                            options={allAccounts?.result?.data?.map((option: any) => ({
                                                                label: option?.accountName,
                                                                value: option?.accountId
                                                            }))}
                                                            value={
                                                                formik.values?.lst_Account?.id
                                                                    ? {
                                                                        value: formik.values?.lst_Account?.id,
                                                                        label: formik.values?.lst_Account?.value || ''
                                                                    }
                                                                    :
                                                                    AccountId && AccountName ?
                                                                        {
                                                                            value: AccountId,
                                                                            label: AccountName,
                                                                        }
                                                                        :
                                                                        null
                                                            }
                                                            isDisabled={AccountId || viewOnly}
                                                            onChange={(selectedOption: any) => {
                                                                formik.setFieldValue('lst_Account.id', selectedOption.value);
                                                                formik.setFieldValue('lst_Account.value', selectedOption.label);
                                                            }}
                                                        />
                                                    </div>
                                                    {formik.touched.lst_Account && formik.errors.lst_Account && (
                                                        <div className="error">{formik.errors.lst_Account?.value}</div>
                                                    )}
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-wrap">
                                                        <label className="input-label">Marital Status</label>
                                                        <Select
                                                            styles={customStyles}
                                                            className="select"
                                                            options={getContactLookup?.result?.maritalStatusTypes?.map((option: any) => ({
                                                                label: option?.name,
                                                                value: option?.id
                                                            }))}
                                                            isDisabled={viewOnly}
                                                            onChange={(selectedOption: any) => {
                                                                formik.setFieldValue('martialStatusId', selectedOption);
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="user-accordion-item">
                                    <Link
                                        to="#"
                                        className="accordion-wrap collapsed"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#edit-address"
                                    >
                                        {/* <span>
                                            <i className="ti ti-map-pin-cog" />
                                        </span> */}
                                        Contact Info
                                    </Link>
                                    <div
                                        className="accordion-collapse collapse"
                                        id="edit-address"
                                        data-bs-parent="#list-accords"
                                    >
                                        <div className="content-collapse">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-wrap">
                                                        <label className='input-label'>
                                                            Home Phone
                                                        </label>
                                                        <InputMask mask="+1(___)___-____"
                                                            replacement={{ _: /\d/ }}
                                                            className="form-control"
                                                            {...formik.getFieldProps("homePhone")}
                                                            disabled={viewOnly}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-wrap">
                                                        <label className='input-label'>
                                                            Work Phone
                                                        </label>
                                                        <InputMask mask="+1(___)___-____"
                                                            replacement={{ _: /\d/ }}
                                                            className="form-control"
                                                            {...formik.getFieldProps("workPhone")}
                                                            disabled={viewOnly}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-wrap">
                                                        <label className='input-label'>
                                                            Cell Phone
                                                        </label>
                                                        <InputMask mask="+1(___)___-____"
                                                            replacement={{ _: /\d/ }}
                                                            className="form-control"
                                                            {...formik.getFieldProps("cellPhone")}
                                                            disabled={viewOnly}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-wrap">
                                                        <label className='input-label'>
                                                            Fax
                                                        </label>
                                                        {/* <input
                                                            type='text'
                                                            className="form-control"
                                                            {...formik.getFieldProps("fax")}
                                                            disabled={viewOnly}
                                                        /> */}
                                                        <InputMask mask="+1(___)___-____"
                                                            replacement={{ _: /\d/ }}
                                                            className="form-control"
                                                            {...formik.getFieldProps("cellPhone")}
                                                            disabled={viewOnly}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className="form-wrap">
                                                        <TextField
                                                            label="Home Email"
                                                            type="email"
                                                            {...formik.getFieldProps("homeEmail")}
                                                            disabled={viewOnly}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-wrap">
                                                        <TextField
                                                            label="Work Email "
                                                            type="email"
                                                            {...formik.getFieldProps("email")}
                                                            disabled={viewOnly}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-wrap">
                                                        <label className="input-label">Preferred Method
                                                            {/* <span className="text-danger">*</span> */}
                                                        </label>
                                                        <Select
                                                            styles={customStyles}
                                                            className="select"
                                                            options={getContactLookup?.result?.preferredMethodTypes?.map((option: any) => ({
                                                                label: option?.name,
                                                                value: option?.id
                                                            }))}
                                                            isDisabled={viewOnly}
                                                            onChange={(selectedOption: any) => {
                                                                formik.setFieldValue('preferredMethodId', selectedOption);
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-wrap">
                                                        <TextField
                                                            label="Preferred Times "
                                                            type="text"
                                                            {...formik.getFieldProps("prefferedTime")}
                                                            disabled={viewOnly}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-wrap">
                                                        <TextField
                                                            label="Address As"
                                                            type="text"
                                                            {...formik.getFieldProps("addressAs")}
                                                            disabled={viewOnly}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6 d-flex align-items-center">
                                                    <div className="radio-wrap">
                                                        <label className="input-label">Status</label>
                                                        <div className="d-flex flex-wrap">
                                                            <div className="radio-btn">
                                                                <input
                                                                    type="radio"
                                                                    className="status-radio"
                                                                    id="active"
                                                                    name="active"
                                                                    value="true"
                                                                    disabled={viewOnly}
                                                                    checked={formik.values.isActive === true}
                                                                    onChange={() => formik.setFieldValue('isActive', true)}
                                                                />
                                                                <label htmlFor="active">Active</label>
                                                            </div>
                                                            <div className="radio-btn">
                                                                <input
                                                                    type="radio"
                                                                    className="status-radio"
                                                                    id="inactive"
                                                                    name="active"
                                                                    value="false"
                                                                    disabled={viewOnly}
                                                                    checked={formik.values.isActive === false}
                                                                    onChange={() => formik.setFieldValue('isActive', false)}
                                                                />
                                                                <label htmlFor="inactive">Inactive</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <label className="input-label">
                                                        Unsubscribe from Newsletter?
                                                    </label>
                                                    <label className="checkboxs mt-2 mb-5">
                                                        <input
                                                            type="checkbox"
                                                            defaultChecked
                                                            disabled={viewOnly}
                                                            {...formik.getFieldProps("isSubNewsLetter")}
                                                        />
                                                        <span className="checkmarks" />
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="user-accordion-item">
                                    <Link
                                        to="#"
                                        className="accordion-wrap collapsed"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#mailing-address"
                                    >
                                        {/* <span>
                                            <i className="ti ti-map-pin-cog" />
                                        </span> */}
                                        Mailing Address
                                    </Link>
                                    <div
                                        className="accordion-collapse collapse"
                                        id="mailing-address"
                                        data-bs-parent="#list-accords"
                                    >
                                        <div className="content-collapse">
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="form-wrap">
                                                        <TextField
                                                            label="Address Line 1"
                                                            type="text"
                                                            {...formik.getFieldProps("mailingAddress.addressLine1")}
                                                            disabled={viewOnly}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="form-wrap">
                                                        <TextField
                                                            label="Address Line 2 "
                                                            type="text"
                                                            {...formik.getFieldProps("mailingAddress.addressLine2")}
                                                            disabled={viewOnly}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-wrap">
                                                        <TextField
                                                            label="City "
                                                            type="text"
                                                            {...formik.getFieldProps("mailingAddress.cityName")}
                                                            disabled={viewOnly}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-wrap">
                                                        <TextField
                                                            label="State/Region "
                                                            type="text"
                                                            {...formik.getFieldProps("mailingAddress.stateName")}
                                                            disabled={viewOnly}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="form-wrap">
                                                        <TextField
                                                            label="ZipCode "
                                                            type="text"
                                                            {...formik.getFieldProps("zipcode")}
                                                            disabled={viewOnly}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="user-accordion-item">
                                    <Link
                                        to="#"
                                        className="accordion-wrap collapsed"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#contact-source"
                                    >
                                        {/* <span>
                                            <i className="ti ti-map-pin-cog" />
                                        </span> */}
                                        Contact Source Info
                                    </Link>
                                    <div
                                        className="accordion-collapse collapse"
                                        id="contact-source"
                                        data-bs-parent="#list-accords"
                                    >
                                        <div className="content-collapse">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-wrap">
                                                        <label className="input-label">Inquiry Method
                                                            {/* <span className="text-danger">*</span> */}
                                                        </label>
                                                        <Select
                                                            styles={customStyles}
                                                            className="select"
                                                            options={getContactLookup?.result?.inquiryMethodTypes?.map((option: any) => ({
                                                                label: option?.name,
                                                                value: option?.id
                                                            }))}
                                                            isDisabled={viewOnly}
                                                            onChange={(selectedOption: any) => {
                                                                formik.setFieldValue('inquiryMethod', selectedOption);
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-wrap">
                                                        <label className="input-label">Lead Source </label>
                                                        <Select
                                                            styles={customStyles}
                                                            className="select"
                                                            options={getContactLookup?.result?.leadSourceType?.map((option: any) => ({
                                                                label: option?.name,
                                                                value: option?.id
                                                            }))}
                                                            value={
                                                                formik.values?.leadSource?.id
                                                                    ? {
                                                                        value: formik.values?.leadSource?.id,
                                                                        label: formik.values?.leadSource?.name || '',
                                                                    }
                                                                    : null
                                                            }
                                                            isDisabled={viewOnly}
                                                            onChange={(selectedOption: any) => {
                                                                formik.setFieldValue('leadSource.id', selectedOption.value);
                                                                formik.setFieldValue('leadSource.name', selectedOption.label);
                                                            }}

                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="form-wrap">
                                                        <label className="input-label ">Source Description
                                                            {/* <span className="text-danger">*</span> */}
                                                        </label>
                                                        <TextArea
                                                            className="form-control height-150"
                                                            defaultValue="21213"
                                                            disabled={viewOnly}
                                                            {...formik.getFieldProps("sourceDescription")}

                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </form>
                        <div className="submit-button text-end">
                            <button type='button' className="btn btn-light sidebar-close" onClick={closeSidebar}>
                                Cancel
                            </button>
                            {!viewOnly ? (
                                <button type="submit" onClick={handleSubmit} className="btn btn-primary">
                                    {isEditing ? "Update" : 'Add'}
                                </button>
                            ) : (
                                <>
                                </>
                            )
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactsSidebar;
